const tags = {
    general: "mdi-chart-bubble",
    tlc_fixed: "mdi-phone",
    tlc_mobile: "mdi-phone",
    electricity: "mdi-lightning-bolt",
    gas: "mdi-fire",
    ele_gas: "mdi-gauge",
    water: "mdi-water",
    cleaning: "mdi-spray-bottle",
    material: "mdi-wrench",
    transport: "mdi-truck",
    human_resources: "mdi-account-group",
    warehouse: "mdi-warehouse",
    logistic: "mdi-human-dolly",
    waste_disposal: "mdi-dump-truck",
    car_fleet: "mdi-car-multiple",
    sustainability: "mdi-sprout",
    AI: "mdi-creation"
};

let icons = {
    chevronDown: "mdi-chevron-down",
    chevronLeft: "mdi-chevron-down",
    arrowUp: "mdi-sort-descending",
    arrowDown: "mdi-sort-ascending",
    arrowUpDown: "mdi-swap-vertical",

    open: "mdi-open-in-new",
    openInApp: "mdi-open-in-app",
    login: "mdi-login",
    logout: "mdi-logout",
    clear: "mdi-close",
    close: "mdi-close-circle-outline",
    add: "mdi-plus",
    check: "mdi-check",
    refresh: "mdi-refresh",
    sync: "mdi-sync",
    verticalDots: "mdi-dots-vertical",
    magnify: "mdi-magnify",
    calendar: "mdi-calendar-outline",
    save: "mdi-content-save",
    copy: "mdi-content-copy",
    send: "mdi-send",
    attach: "mdi-paperclip",
    addAttachment: "mdi-paperclip-plus",
    help: "mdi-help-circle-outline",
    info: "mdi-information-outline",
    home: "mdi-home",
    shieldHome: "mdi-shield-home-outline",

    share: "mdi-share-variant",
    shareOutline: "mdi-share-variant-outline",
    shareAll: "mdi-share-all",

    allWorkspace: "mdi-folder-account-outline",
    backoffice: "mdi-shield-crown-outline",

    delete: "mdi-trash-can",
    deleteOutline: "mdi-trash-can-outline",

    notification: "mdi-bell-outline",
    notificationRead: "mdi-email-outline",
    notificationToRead: "mdi-email-open-outline",

    selectOff: "mdi-select-off",

    search: "mdi-magnify",
    searchByTag: "mdi-tag-search",

    download: "mdi-download",
    downloadOutline: "mdi-download-outline",
    upload: "mdi-upload",
    uploadCloud: "mdi-cloud-upload",

    circle: "mdi-circle",

    filter: "mdi-filter-variant",
    filterRemove: "mdi-filter-variant-remove",
    filterable: "mdi-filter",
    filtered: "mdi-filter-outline",

    noData: "mdi-database-remove-outline",

    user: "mdi-account-plus-outline",
    account: {
        add: "mdi-account-plus-outline",
        my: "mdi-account-circle-outline",
        edit: "mdi-account-edit-outline",
        softwareToken: {
            phone: "mdi-cellphone",
            removePhone: "mdi-cellphone-remove",
            scanQr: "mdi-qrcode-scan",
            securityCheck: "mdi-lock-check-outline"
        }
    },

    email: {
        seal: "mdi-email-seal-outline",
        send: "mdi-email-arrow-right-outline"
    },

    reports: {
        all: "mdi-chart-box-multiple-outline",
        my: "mdi-chart-box-outline",
        shared: "mdi-account-file-text-outline",
        isOwner: "mdi-chart-box-outline",
        isSharedWithMe: "mdi-account-file-text-outline",
        unpinned: "mdi-pin-outline",
        pinned: "mdi-pin",
        writtenBy: "mdi-feather",
        modify: "mdi-filter-variant",
        newVersion: "mdi-pen-plus",
        scrollToTop: "mdi-arrow-up-circle-outline",
        scrollToBottom: "mdi-arrow-down-circle-outline",
        print: "mdi-printer",
        status: {
            CREATED: "mdi-check-circle",
            IN_PROGRESS: "mdi-cogs",
            FAILED: "mdi-human-male-board-poll"
        },
        placeholder: {
            welcome: "mdi-party-poppe",
            others: "mdi-chart-box-outline"
        },
        search: {
            byStatus: "mdi-layers-search",
            byDate: "mdi-calendar-outline"
        },
        create: "mdi-file-document-plus-outline",
        createAI: tags.AI,
        changeTitleDescription: "mdi-file-edit-outline",
        excel: "mdi-file-excel",
        divider: "mdi-drag-vertical"
    },
    vaults: {
        all: "mdi-file-cabinet",
        my: "mdi-archive-outline",
        shared: "mdi-file-account-outline",
        isOwner: "mdi-archive-outline",
        isSharedWithMe: "mdi-archive-star-outline",
        search: {
            byStatus: "mdi-layers-search",
            byName: "mdi-card-search"
        },
        create: "mdi-archive-plus-outline",
        breadcrumb: {
            home: "mdi-folder-home-outline",
            arrowRight: "mdi-chevron-right"
        },
        runPipeline: "mdi-play-circle-outline",
        selectAll: "mdi-select",
        deselectAll: "mdi-close",
        move: "mdi-cursor-move",
        addFolder: "mdi-folder-plus-outline",
        rename: "mdi-rename-outline",
        addNote: "mdi-tag-outline",
        edit: "mdi-folder-edit-outline",
        fileStatuses: {
            READY: "mdi-file-outline",
            TAGGING: "mdi-file-settings-outline",
            ARCHIVED: "mdi-file-eye-outline",
            INDEXING: "mdi-file-cog-outline",
            INDEXED: "mdi-file-check-outline",
            ERROR: "mdi-file-remove-outline"
        },
        note: "mdi-tag-outline",
        folder: "mdi-folder-outline",
        folderHome: "mdi-folder-home-outline",
        document: "mdi-file-document-outline",
        survey: {
            answer: "mdi-clipboard-edit-outline",
            experimental: "mdi-flask-outline",
            reset: "mdi-filter-variant-remove",
            validationOk: "mdi-playlist-check",
            validationError: "mdi-note-alert-outline",
            save: "mdi-content-save-check-outline"
        }
    },
    analysis: {
        experimental: "mdi-flask-outline",
        reset: "mdi-filter-variant-remove",
        selectOne: "mdi-text-box-multiple-outline",
        analyze: "mdi-cogs",
        validationError: "mdi-note-alert-outline"
    },
    alerts: {
        generic: "mdi-alert-circle-outline",
        success: "mdi-check-circle",
        denied: "mdi-alert-octagon"
    },
    permissions: {
        reader: "mdi-eye",
        writer: "mdi-pencil",
        moderator: "mdi-wrench",
        owner: "mdi-account-tie-hat-outline"
    },
    editor: {
        undo: "mdi-undo",
        redo: "mdi-redo",
        h1: "mdi-format-header-1",
        h2: "mdi-format-header-2",
        h3: "mdi-format-header-3",
        italic: "mdi-format-italic",
        bold: "mdi-format-bold",
        alignLeft: "mdi-format-align-left",
        alignRight: "mdi-format-align-right",
        bulletedList: "mdi-format-list-bulleted",
        numberedList: "mdi-format-list-numbered",
        highlight: "mdi-format-color-highlight",
        link: "mdi-link",
        addImage: "mdi-image-plus-outline",
        scaleUpImage: "mdi-magnify-plus",
        scaleDownImage: "mdi-magnify-minus",
        table: {
            plus: "mdi-table-plus",
            minus: "mdi-table-minus",
            columnAdd: "mdi-table-column-plus-after",
            columnRemove: "mdi-table-column-remove",
            rowAdd: "mdi-table-row-plus-after",
            rowRemove: "mdi-table-row-remove"
        }
    },

    tags: tags
};

export default icons;
